// Tracks vertical scroll velocity (px/s) with a passive listener and rAF
// sampling, so the library grid can widen its lookahead when the user flings.

import { useEffect, useRef } from "react";

export function useScrollVelocity() {
  const velocity = useRef(0);

  useEffect(() => {
    let lastY = window.scrollY;
    let lastT = performance.now();
    let ticking = false;
    let decay: ReturnType<typeof setTimeout> | null = null;

    const sample = () => {
      ticking = false;
      const y = window.scrollY;
      const t = performance.now();
      const dt = t - lastT;
      if (dt > 8) {
        const v = (Math.abs(y - lastY) / dt) * 1000;
        // Smooth so a single jittery frame doesn't spike the lookahead.
        velocity.current = velocity.current * 0.6 + v * 0.4;
        lastY = y;
        lastT = t;
      }
      if (decay) clearTimeout(decay);
      decay = setTimeout(() => {
        velocity.current = 0;
      }, 160);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sample);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (decay) clearTimeout(decay);
    };
  }, []);

  return velocity;
}
